import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoaderService } from 'src/app/Services/loader.service';
import { WebsiteService } from 'src/app/Services/website.service';

@Injectable()
export class BCFocusResolver implements Resolve<any> {

    constructor(private websiteservice: WebsiteService,
        private loaderService: LoaderService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        this.loaderService.showLoader();

        let bcid = route.params['bcid'];
        let kpiId = route.params['kpiId'];
        let year = route.params['year'];
        let quarter = route.params['quarter'];

        return this.websiteservice.GetBcKpiDetails(bcid, kpiId, year, quarter).pipe(
            map((dataFromApi) => dataFromApi),
            catchError((err) => Observable.throw(err))
        )
    }
}